import React from 'react'

import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const Icon60FirewallDisable = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 40 48'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M39.998,17.866 C40.000,18.225 39.907,41.045 20.332,47.942 C20.327,47.944 20.321,47.943 20.315,47.945 C20.214,47.979 20.108,47.999 20.000,47.999 C19.892,47.999 19.786,47.979 19.685,47.945 C19.679,47.943 19.673,47.944 19.668,47.942 C0.096,41.045 0.000,18.225 0.002,17.866 C0.002,17.866 0.002,17.866 0.002,17.866 L0.002,7.999 C0.002,6.897 0.899,5.998 2.002,5.998 L5.654,5.998 C5.662,5.998 5.669,6.003 5.678,6.003 C5.687,6.003 5.694,5.998 5.703,5.998 C15.360,5.998 18.963,0.681 19.112,0.454 C19.297,0.173 19.613,-0.001 19.950,-0.001 C20.290,-0.001 20.706,0.172 20.890,0.457 C21.037,0.680 24.642,5.998 34.298,5.998 C34.307,5.998 34.314,6.003 34.323,6.004 C34.333,6.003 34.340,5.998 34.349,5.998 L37.998,5.998 C39.101,5.998 39.998,6.897 39.998,7.999 L39.998,17.866 C39.998,17.866 39.998,17.866 39.998,17.866 ZM37.998,17.866 L37.998,7.999 L34.349,7.999 C34.340,7.999 34.333,7.994 34.323,7.994 C34.314,7.994 34.307,7.999 34.298,7.999 C26.003,7.999 21.651,4.348 20.000,2.533 C18.350,4.348 13.999,7.999 5.703,7.999 C5.694,7.999 5.687,7.995 5.678,7.994 C5.669,7.995 5.662,7.999 5.654,7.999 L2.002,7.999 L2.002,17.866 C2.002,17.867 2.001,17.868 2.001,17.870 C2.001,17.871 2.002,17.873 2.002,17.874 C2.000,18.090 2.074,39.343 20.000,45.926 C37.958,39.333 38.000,18.090 37.998,17.874 C37.998,17.873 37.999,17.871 37.999,17.870 C37.999,17.868 37.998,17.867 37.998,17.866 ZM25.706,29.706 C25.511,29.901 25.255,29.999 24.999,29.999 C24.744,29.999 24.488,29.901 24.293,29.706 L20.000,25.413 L15.707,29.706 C15.512,29.901 15.256,29.999 15.000,29.999 C14.745,29.999 14.489,29.901 14.294,29.706 C13.903,29.316 13.903,28.683 14.294,28.292 L18.586,23.999 L14.294,19.706 C13.903,19.315 13.903,18.682 14.294,18.292 C14.684,17.901 15.317,17.901 15.707,18.292 L20.000,22.585 L24.293,18.292 C24.683,17.901 25.316,17.901 25.706,18.292 C26.097,18.682 26.097,19.315 25.706,19.706 L21.414,23.999 L25.706,28.292 C26.097,28.683 26.097,29.316 25.706,29.706 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

Icon60FirewallDisable.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
